import {
    SCHEDULED_REPORTS_OPEN_MODAL,
    SCHEDULED_REPORTS_CONTACTS_OPEN_MODAL,
} from 'Redux/actionTypes';

export const scheduledReportsOpenModal = (open, detail) => ({
    type: SCHEDULED_REPORTS_OPEN_MODAL,
    payload: { open, detail }
})

export const scheduledReportsContactsOpenModal = (open, contacts) => ({
    type: SCHEDULED_REPORTS_CONTACTS_OPEN_MODAL,
    payload: { open, contacts }
})